import { render, staticRenderFns } from "./NSSIPage.vue?vue&type=template&id=dbda946a&"
import script from "./NSSIPage.vue?vue&type=script&lang=js&"
export * from "./NSSIPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports